module.exports = __webpack_public_path__ + "img/Foto_InteraktMediaDes-GH-8380_2019.5d71cebb.jpg";